import { ElementState, Preview } from "@creatomate/preview";

import { deepClone } from "app/utils";

const rearrangeTracks = async (
  track: number, direction: "up" | "down", preview: Preview, newTrack?: number
): Promise<void> => {
  if (!preview || !preview.state) return;

  // The track number to swap with
  const targetTrack = newTrack || direction === "up" ? track + 1 : track - 1;
  if (targetTrack < 1) return;

  // Elements at provided track
  const elementsCurrentTrack = preview.state.elements.filter(
    (element: ElementState) => element.track === track
  );
  if (elementsCurrentTrack.length === 0) return;

  // Clone the current renderer state
  const state = deepClone(preview.state);

  // Swap track numbers
  const elements = preview.state.elements.map(element => {
    if (element.track === track) {
      return { ...element, source: { ...element.source, track: targetTrack } };
    }
    if (element.track === targetTrack) {
      return { ...element, source: { ...element.source, track } };
    }
    return { ...element };
  });

  // Set source by the mutated state
  await preview.setSource(preview.getSource({ ...state, elements }), true);
};

export default rearrangeTracks;
